import { Component, OnInit } from '@angular/core';
import { TegelModule } from '@scania/tegel-angular-17';
import { Toast, ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  imports: [TegelModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit {
  toast: Toast | null = null;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toast$.subscribe((toast) => {
      this.toast = toast;
      setTimeout(() => {
        this.toast = null; // Remove o toast após 5 segundos (ou o tempo que você preferir)
      }, 5000);
    });
  }
}
